import { type CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveId = (state: CoreState): string | undefined => {
  return findActiveBrand(state)?.id
}
